import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';

import {CommunicationService} from '../services/communication.service';
import {MessagesData, SendMessageRequest, SendMessageResponse} from './messages.domain';

@Injectable()

export class MessagesService {
  constructor(private communicationService: CommunicationService) {
  }

  getAllMessages(): Observable<MessagesData> {
    return this.communicationService.getData('message');
  }

  updateMessageReadStatus(messageId: number): Observable<MessagesData> {
    const requestData = {
      message: [{
        message_read: '1',
      }]
    };
    return this.communicationService.updateData(`message?message_id=${messageId}`, requestData);
  }

  sendNewMessage(requestData: SendMessageRequest): Observable<SendMessageResponse> {
    return this.communicationService.postData('message', requestData);
  }

  sendMessageToAll(requestData: SendMessageRequest, role: string): Observable<SendMessageResponse> {
    return this.communicationService.postData(`message/broadcast?role=${role}`, requestData);
  }
}
